import { Permission, TenantFlow } from '../enums';
import { MenuItem } from '../interfaces';
import { TenantConfigurationService } from '@lib/services';

/**
 * Checks if the tenant has access to a specific flow and returns the provided permissions
 * if allowed, or an empty array if not allowed.
 *
 * @param permissions - An array of permission strings to return if access is allowed.
 * @returns An array of permissions if the tenant is allowed, otherwise an empty array.
 */
function isTenantAccessAllowed(permissions: string[], flow: TenantFlow) {
    const tenantConfigService = new TenantConfigurationService();

    return tenantConfigService.isTenantAllowed(localStorage.getItem('tenantKey') || '', flow) ? permissions : [''];
}

export const getMenuItems: () => MenuItem[] = () => [
    {
        title: 'Home',
        icon: 'home',
        link: '/home',
        permissions: [Permission.ProductManagement, Permission.CardProducts],
    },
    {
        title: 'Analytics',
        icon: 'report',
        link: '/report',
        permissions: [Permission.ProductManagement, Permission.CardProducts],
    },
    {
        title: 'Customers',
        icon: 'customer',
        link: '/customers',
        permissions: [Permission.Customer],
    },
    {
        title: 'Agents',
        icon: 'customer',
        link: '/agents',
        permissions: isTenantAccessAllowed([Permission.Customer], TenantFlow.AGENT_SEPARATE_MODULE),
    },
    {
        title: 'Card Product',
        icon: 'product',
        link: '/card-product',
        permissions: [Permission.ProductManagement, Permission.CardProducts],
    },
    {
        title: 'Access Management',
        icon: 'access-management',
        link: '/access-management',
        permissions: [Permission.AccessManagement],
    },
    {
        title: 'Atm',
        icon: 'atm-icon',
        link: '/atm',
        permissions: [Permission.Locations],
    },
    {
        title: 'Exchange Rate',
        icon: 'customer-operations',
        link: '/exchange-rate-managment',
        permissions: [Permission.FxRates],
    },
    {
        title: 'Customer Cash-In/Out',
        icon: 'customer-operations',
        link: '/customer-operations',
        permissions: [Permission.CardLessVouchers],
    },
    {
        title: 'Transactions',
        icon: 'transaction',
        link: '/transactions',
        permissions: [Permission.Transactions],
    },
    {
        title: 'Cards',
        icon: 'card-icon-sidemenu',
        link: '/cards',
        permissions: [Permission.Cards],
    },
    {
        title: 'Card Request',
        icon: 'card-icon-sidemenu',
        link: '/card-request',
        permissions: isTenantAccessAllowed([Permission.CustomerCardRequest], TenantFlow.CARD_REQUEST_ACCESS_ALLOWED),
    },
    {
        title: 'Pending Requests',
        icon: 'card-icon-sidemenu',
        link: '/pending-requests',
        permissions: isTenantAccessAllowed([], TenantFlow.PENDING_REQUESTS_MODULE),
    },
    {
        title: 'Product Settings',
        icon: 'settings',
        link: '/product-settings',
        permissions: [Permission.ProductSettings],
    },
    {
        title: 'Bulk Upload Cash',
        icon: 'upload',
        link: '/bulk-upload-cash',
        permissions: [Permission.BulkUpload],
    },
    {
        title: 'Call Center',
        icon: 'customer',
        link: '/call-center',
        permissions: [Permission.Customer],
    },
    // {
    //     title: 'Faq',
    //     icon: 'faq-icon',
    //     link: '/faq',
    //     permissions: [Permission.Faq],
    // },
];

export const lowerMenuItems: MenuItem[] = [
    {
        section: 'PERSONAL',
        title: 'Feedback',
        icon: 'feedback',
        permissions: [],
        link: '/feedback',
    },
    {
        title: 'Settings',
        icon: 'settings',
        permissions: [Permission.Settings, Permission.Logo],
        link: '/control-center/settings',
    },
    {
        section: 'MANUALS',
        title: 'API Catalog',
        icon: 'api-catalog',
        permissions: [],
        external: true,
        link: 'https://nymcard.com/docs/api',
    },
    {
        title: 'Getting Started Guide',
        icon: 'guide',
        permissions: [],
        external: true,
        link: 'https://docs.nymcard.com/',
    },
];
